export default "__VITE_ASSET__b68a17a5__"